import * as React from 'react';
import { FC } from 'react';
import { COLUMN_CLASSES, SectionProps } from './section';
import Carousel from './Carousel';
import GameComponent from './Game';

const SectionCarousel: FC<SectionProps> = ({ gameStarter, paginatedGames, common, labelId }) => (
  <div className={`games_list section__carousel ${COLUMN_CLASSES[common.columns]}`}>
    <Carousel show={2} labelId={labelId}>
      {paginatedGames.data.map((game) => (
        <GameComponent key={game.id} gameStarter={gameStarter} game={game} common={common} />
      ))}
    </Carousel>
  </div>
);

export default SectionCarousel;
